import { useEffect, useState } from "react";

/**
 * Latch for the "mount once, then keep mounted via `display: none`" tab pattern.
 * Returns `false` until `isActive` first becomes true, then stays `true` for the rest
 * of the component's life. This lets a heavy tab's subtree be created lazily on first
 * visit and never unmount (preserving its state / scroll / in-flight queries) when the
 * user switches away.
 */
export const useKeepMountedOnceActive = (isActive: boolean): boolean => {
	const [hasBeenActive, setHasBeenActive] = useState(false);
	useEffect(() => {
		if (isActive) setHasBeenActive(true);
	}, [isActive]);
	return hasBeenActive;
};
